import _ from 'lodash'
import { GetterTree } from 'vuex';
import { Timesheet, TimesheetsState } from '@/store/timesheets/types';
import { RootState } from '@/store/types';

const getters : GetterTree<TimesheetsState, RootState> = {
  /**
   * タイムシートを検索する
   * @param state {{
   * tutorId: string,
   * yearMonth: string, // YYYYMM
   * }}
   * @returns {Timesheet|undefined}
   */
  findTimesheet: (state) => (
    { tutorId, yearMonth }: { tutorId: string, yearMonth: string },
  ) => _.chain(state.timesheets)
    .find((t: Timesheet) => t.tutor?.id === tutorId && t.date.format('YYYYMM') === yearMonth)
    .value(),
};

export default getters;
